import { StyleRules } from "@mui/styles";

export const breadcrumbsStyle: StyleRules = {
  breadcrumbs: {
    display: "flex",
    gap: "0.25rem",
    fontSize: "1.125rem"
  }
}
